module.exports = __webpack_public_path__ + "img/info.729caa27.png";